export const PRICE_CODES = [22, 23, 24]
export const WEIGHT_CODES = [21, 27]
export const PRICE_WEIGHT_CODES = [...PRICE_CODES, ...WEIGHT_CODES]
